import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./Checkot.css";

export default function Checkout() {

    const { state } = useLocation();
    const navigate = useNavigate();

    const cartItems = state?.cartItems || [];
    const grandTotal = Number(state?.grandTotal || 0);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        address: ""
    });

    const [loading, setLoading] = useState(false);

    const userEmail = localStorage.getItem("userEmail");

    const savedUser = JSON.parse(
        localStorage.getItem("user") || "null"
    );

    const savedWallet = localStorage.getItem("coffeeWallet");

    const wallet = savedWallet
        ? JSON.parse(savedWallet)
        : null;

    const isSubscribed = wallet?.subscribed === true;

    const walletBalance = isSubscribed
        ? Number(wallet.balance || 0)
        : 0;

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const itemsText = cartItems
        .map(
            (item) =>
                `${item.name} x ${item.qty} = ₹${item.price * item.qty}`
        )
        .join("\n");

    // ==============================
    // WHATSAPP BILL
    // ==============================

    const sendWhatsAppBill = (
        order,
        paymentMethod,
        remainingBalance = null
    ) => {

        const whatsappMessage = `
🧾 *SRINEEVI COFFEE HOUSE*
━━━━━━━━━━━━━━━━━━━━

🎉 *ORDER CONFIRMED*

🆔 Order ID: #${order.id}

👤 Customer:
${formData.name}

📞 Phone:
${formData.phone}

📍 Delivery Address:
${formData.address}

━━━━━━━━━━━━━━━━━━━━
🛒 *ORDER ITEMS*
━━━━━━━━━━━━━━━━━━━━

${cartItems
    .map(
        (item) =>
            `☕ ${item.name} × ${item.qty} = ₹${item.price * item.qty}`
    )
    .join("\n")}

━━━━━━━━━━━━━━━━━━━━

💰 *TOTAL: ₹${grandTotal}*

💳 Payment:
${paymentMethod}

${
    remainingBalance !== null
        ? `💼 Wallet Balance After Order: ₹${remainingBalance}`
        : ""
}

━━━━━━━━━━━━━━━━━━━━

❤️ Thank you for ordering from
*Srineevi Coffee House!*

☕ Enjoy your order!
`;

        const encodedMessage =
            encodeURIComponent(whatsappMessage);

        // SHOP WHATSAPP NUMBER
        const shopWhatsAppNumber = "919092330880";

        const whatsappUrl =
            `https://wa.me/${shopWhatsAppNumber}?text=${encodedMessage}`;

        window.open(
            whatsappUrl,
            "_blank"
        );
    };

    // ==============================
    // EMAIL
    // ==============================

    const sendOrderEmail = async (
        paymentMethod,
        remainingBalance,
        orderId
    ) => {

        const templateParams = {

            to_email: userEmail,

            user_name:
                savedUser?.name ||
                formData.name ||
                "Customer",

            subject:
                "Order Confirmed - Srineevi Coffee House",

            message:
                `🧾 SRINEEVI COFFEE HOUSE\n\n` +
                `🎉 Your order has been placed successfully!\n\n` +
                `Order ID: #${orderId}\n\n` +
                `Customer Name: ${formData.name}\n` +
                `Phone: ${formData.phone}\n` +
                `Address: ${formData.address}\n\n` +
                `ORDER ITEMS:\n${itemsText}\n\n` +
                `Total Amount: ₹${grandTotal}\n\n` +
                `Payment Method: ${paymentMethod}\n\n` +
                `Remaining Wallet Balance: ₹${remainingBalance}\n\n` +
                `Thank you for ordering from Srineevi Coffee House! ❤️`,

            amount: grandTotal,

            bonus_amount: 0,

            wallet_balance: remainingBalance
        };

        return await emailjs.send(
            "service_qbq1lp9",
            "template_cyktmda",
            templateParams,
            {
                publicKey: "Wgjv8Tc07Rk4_kZaL"
            }
        );
    };

    // ==============================
    // PLACE ORDER
    // ==============================

    const handlePlaceOrder = async (e) => {

        e.preventDefault();

        if (
            !formData.name.trim() ||
            !formData.phone.trim() ||
            !formData.address.trim()
        ) {

            alert("⚠️ Please fill all delivery details!");
            return;
        }

        if (cartItems.length === 0) {

            alert("🛒 Your cart is empty!");
            navigate("/product");
            return;
        }

        if (!userEmail) {

            alert("⚠️ Please login before placing an order!");
            navigate("/login");
            return;
        }

        setLoading(true);

        // ==============================
        // SUBSCRIBED CUSTOMER
        // ==============================

        if (isSubscribed) {

            if (walletBalance < grandTotal) {

                setLoading(false);

                alert(
                    `❌ Insufficient Wallet Balance!\n\n` +
                    `Wallet Balance: ₹${walletBalance}\n` +
                    `Order Amount: ₹${grandTotal}`
                );

                return;
            }

            const remainingBalance =
                walletBalance - grandTotal;

            const updatedWallet = {
                ...wallet,
                balance: remainingBalance,
                lastOrderAmount: grandTotal,
                lastOrderDate: new Date().toISOString()
            };

            localStorage.setItem(
                "coffeeWallet",
                JSON.stringify(updatedWallet)
            );

            const order = {

                id: Date.now(),

                customer: formData,

                items: cartItems,

                total: grandTotal,

                paymentMethod:
                    "Subscription Wallet",

                remainingWalletBalance:
                    remainingBalance,

                orderDate:
                    new Date().toISOString()
            };

            localStorage.setItem(
                "lastOrder",
                JSON.stringify(order)
            );

            let emailSuccess = false;

            try {

                await sendOrderEmail(
                    "Subscription Wallet",
                    remainingBalance,
                    order.id
                );

                emailSuccess = true;

            } catch (error) {

                console.error(
                    "ORDER EMAIL ERROR:",
                    error
                );
            }

            localStorage.removeItem("cart");

            setLoading(false);

            sendWhatsAppBill(
                order,
                "Subscription Wallet",
                remainingBalance
            );

            alert(
                `🎉 Order Placed Successfully!\n\n` +
                `Order Amount: ₹${grandTotal}\n` +
                `Remaining Balance: ₹${remainingBalance}\n\n` +
                `${
                    emailSuccess
                        ? "📧 Email bill sent!"
                        : "⚠️ Email could not be sent."
                }\n\n` +
                `📱 WhatsApp bill opened.`
            );

            navigate("/success");

            return;
        }

        // ==============================
        // NORMAL CUSTOMER
        // ==============================

        const order = {

            id: Date.now(),

            customer: formData,

            items: cartItems,

            total: grandTotal,

            paymentMethod:
                "Normal Order",

            orderDate:
                new Date().toISOString()
        };

        localStorage.setItem(
            "lastOrder",
            JSON.stringify(order)
        );

        let emailSuccess = false;

        try {

            await sendOrderEmail(
                "Normal Order",
                "Not subscribed",
                order.id
            );

            emailSuccess = true;

        } catch (error) {

            console.error(
                "NORMAL ORDER EMAIL ERROR:",
                error
            );
        }

        localStorage.removeItem("cart");

        setLoading(false);

        sendWhatsAppBill(
            order,
            "Normal Order"
        );

        alert(
            `🎉 Order Placed Successfully!\n\n` +
            `Order Amount: ₹${grandTotal}\n\n` +
            `${
                emailSuccess
                    ? "📧 Email bill sent!"
                    : "⚠️ Email could not be sent."
            }\n\n` +
            `📱 WhatsApp bill opened.`
        );

        navigate("/success");
    };

    return (

        <div className="checkout-page">

            <div className="checkout-container">

                <h1>Checkout</h1>

                <div className="checkout-summary">

                    <h2>🛒 Order Summary</h2>

                    {cartItems.map(
                        (item, index) => (

                            <div
                                className="checkout-item"
                                key={index}
                            >

                                <span>
                                    {item.name} × {item.qty}
                                </span>

                                <strong>
                                    ₹{item.price * item.qty}
                                </strong>

                            </div>
                        )
                    )}

                    <hr />

                    <div className="checkout-total">

                        <span>
                            Grand Total
                        </span>

                        <strong>
                            ₹{grandTotal}
                        </strong>

                    </div>

                </div>

                <div className="checkout-form">

                    <h2>📦 Delivery Details</h2>

                    <p>
                        Enter your delivery details
                    </p>

                    <form onSubmit={handlePlaceOrder}>

                        <input
                            id="checkout-name"
                            type="text"
                            name="name"
                            placeholder="Enter your name"
                            value={formData.name}
                            onChange={handleChange}
                            autoComplete="name"
                            required
                        />

                        <input
                            id="checkout-phone"
                            type="tel"
                            name="phone"
                            placeholder="Enter WhatsApp number"
                            value={formData.phone}
                            onChange={handleChange}
                            autoComplete="tel"
                            required
                        />

                        <textarea
                            id="checkout-address"
                            name="address"
                            placeholder="Enter delivery address"
                            rows="4"
                            value={formData.address}
                            onChange={handleChange}
                            autoComplete="street-address"
                            required
                        />

                        {isSubscribed && (

                            <div className="wallet-payment">

                                <h3>
                                    ☕ Subscription Wallet
                                </h3>

                                <p>
                                    Available Balance:
                                    <strong>
                                        ₹{walletBalance}
                                    </strong>
                                </p>

                                <p>
                                    Order Amount:
                                    <strong>
                                        ₹{grandTotal}
                                    </strong>
                                </p>

                                <p>
                                    Remaining Balance:
                                    <strong>
                                        ₹
                                        {Math.max(
                                            0,
                                            walletBalance -
                                            grandTotal
                                        )}
                                    </strong>
                                </p>

                            </div>
                        )}

                        {!isSubscribed && (

                            <div className="normal-payment">

                                <h3>
                                    💳 Normal Order
                                </h3>

                                <p>
                                    You are not subscribed.
                                    Your order will be placed normally.
                                </p>

                            </div>
                        )}

                        <button
                            type="submit"
                            className="place-order-btn"
                            disabled={loading}
                        >
                            {loading
                                ? "Processing..."
                                : `Place Order ₹${grandTotal}`
                            }
                        </button>

                        <button
                            type="button"
                            className="back-checkout-btn"
                            onClick={() =>
                                navigate("/cart")
                            }
                        >
                            ← Back to Cart
                        </button>

                    </form>

                </div>

            </div>

        </div>
    );
}